import { useAllTimeFrameworksQuery } from '../../__generated__/graphql';
import { useServerFeature } from '../../../../hooks/useServerFeature';
import { isTimeBalanceCalculationEnabled } from './useIsTimeBalanceEnabled';

export const useIsTimeBalanceEnabledGlobal = (): boolean => {
  const isTimeBalanceVisible = useServerFeature('Time_Balance');
  const { data } = useAllTimeFrameworksQuery();

  if (!data || !isTimeBalanceVisible) {
    return false;
  }

  return data.manager.timeFrameworks.some(
    (timeFramework) =>
      timeFramework.timeBalanceSettings &&
      isTimeBalanceCalculationEnabled(timeFramework.timeBalanceSettings),
  );
};
